import axios from '@api'

export default {
    getLocationList(json) {
        return axios.post(`api/management/location/list`, JSON.stringify(json));
      },
    getLocationChkDuplicate(json) {
      return axios.post(`api/management/location/chkduplicate`, JSON.stringify(json));
    },
    getLocationListById(locationid) {
        return axios.get(`api/management/location/` + locationid);
      }, 
    saveMasterLocation(jsonLocation) {
      return axios.post(`api/management/location/save/`, jsonLocation);
    },
    deleteMasterLocation(jsonLocation) {
      return axios.put('api/management/location/delete', jsonLocation)
    },
}